import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col, Card, Form } from 'react-bootstrap';
import { isValueEmpty } from '@awp/helpers/utilsReact';
import {
  DASHBOARD_TAB_KEY,
  DASHBOARD_TIMELINE_COLOURS,
  DASHBOARD_COMPLETENESS_COLOURS,
  DASHBOARD_QUALITY_COLOURS,
} from '@awp/constants';
const sotTitleStyle = {
  paddingTop: '0.6rem',
  paddingBottom: '0.6rem',
  display: 'flex',
  alignItems: 'center',
};
const sotColStyle = {
  borderTop: '0.063rem solid #bdc5cc',
  borderLeft: '0.063rem solid #bdc5cc',
  paddingTop: '0.2rem',
  paddingBottom: '0.2rem',
  fontSize: '85%',
};
const sotOutline = {
  outline: '0.063rem solid black',
  padding: '0rem 1rem',
  outlineOffset: '-0.063rem',
};
const indicatorStyle = {
  width: '0.8rem',
  height: '0.8rem',
  fontSize: '0.78rem',
  padding: '0rem',
  marginRight: '0.4rem',
};
const LegendTable = ({ tabKey }) => {
  return (
    <Col xs={12} style={sotOutline}>
      <Row className="bg-primary font-weight-bold text-white" style={{ marginRight: '-1rem' }}>
        <Col style={sotTitleStyle} xs={2}>
          {'Indicator'}
        </Col>
        <Col style={sotTitleStyle} xs={4}>
          {'Summary'}
        </Col>
        <Col style={sotTitleStyle} xs={6}>
          {'Description'}
        </Col>
      </Row>
      {DASHBOARD_TAB_KEY.TIMELINESS === tabKey && (
        <>
          <Row className="bg-white">
            <Col style={sotColStyle} xs={2}>
              <button
                type="button"
                className="btn btn-sm text-white"
                style={{ backgroundColor: `${DASHBOARD_TIMELINE_COLOURS[0]}`, ...indicatorStyle }}
              />
              {'Green'}
            </Col>
            <Col style={sotColStyle} xs={4}>
              {'On Time'}
            </Col>
            <Col style={sotColStyle} xs={6}>
              {'All data has been processed within the timeliness interval'}
            </Col>
          </Row>
          <Row className="bg-white">
            <Col style={sotColStyle} xs={2}>
              <button
                type="button"
                className="btn btn-sm text-white"
                style={{ backgroundColor: `${DASHBOARD_TIMELINE_COLOURS[1]}`, ...indicatorStyle }}
              />
              {'Yellow'}
            </Col>
            <Col style={sotColStyle} xs={4}>
              {'Late'}
            </Col>
            <Col style={sotColStyle} xs={6}>
              {'One or more data has been processed outside the timeliness interval'}
            </Col>
          </Row>
        </>
      )}
      {DASHBOARD_TAB_KEY.COMPLETENESS === tabKey && (
        <>
          <Row className="bg-white">
            <Col style={sotColStyle} xs={2}>
              <button
                type="button"
                className="btn btn-sm text-white"
                style={{ backgroundColor: `${DASHBOARD_COMPLETENESS_COLOURS[0]}`, ...indicatorStyle }}
              />
              {'Green'}
            </Col>
            <Col style={sotColStyle} xs={4}>
              {'Received Expected Data'}
            </Col>
            <Col style={sotColStyle} xs={6}>
              {'All expected sensor data has been processed'}
            </Col>
          </Row>
          <Row className="bg-white">
            <Col style={sotColStyle} xs={2}>
              <button
                type="button"
                className="btn btn-sm text-white"
                style={{ backgroundColor: `${DASHBOARD_COMPLETENESS_COLOURS[2]}`, ...indicatorStyle }}
              />
              {'Red'}
            </Col>
            <Col style={sotColStyle} xs={4}>
              {'Missing Expected Data'}
            </Col>
            <Col style={sotColStyle} xs={6}>
              {'None of the expected sensor data has been processed'}
            </Col>
          </Row>
        </>
      )}
      {DASHBOARD_TAB_KEY.QUALITY === tabKey && (
        <>
          <Row className="bg-white">
            <Col style={sotColStyle} xs={2}>
              <button
                type="button"
                className="btn btn-sm text-white"
                style={{ backgroundColor: `${DASHBOARD_QUALITY_COLOURS[0]}`, ...indicatorStyle }}
              />
              {'Green'}
            </Col>
            <Col style={sotColStyle} xs={4}>
              {'Valid'}
            </Col>
            <Col style={sotColStyle} xs={6}>
              {'All data has a positive confidence level'}
            </Col>
          </Row>
          <Row className="bg-white">
            <Col style={sotColStyle} xs={2}>
              <button
                type="button"
                className="btn btn-sm text-white"
                style={{ backgroundColor: `${DASHBOARD_QUALITY_COLOURS[1]}`, ...indicatorStyle }}
              />
              {'Red'}
            </Col>
            <Col style={sotColStyle} xs={4}>
              {'Invalid'}
            </Col>
            <Col style={sotColStyle} xs={6}>
              {'One or more data has a negtive confidence level'}
            </Col>
          </Row>
        </>
      )}
    </Col>
  );
};

LegendTable.propTypes = {
  tabKey: PropTypes.any.isRequired,
};

export default LegendTable;
